import { NextRouter } from 'next/router'
import { useEffect } from 'react'
import { useDebouncedCallback } from 'use-debounce'

import { EventDetectionMethod, EventType, TestPrepGrade } from '~/behavior-tracking/types'
import { logUserActivity } from '~/behavior-tracking/utility/view-event-logs.utility'

export default function usePageVisitTracker(
  router: NextRouter,
  userId: number | null,
  testPrepGrade?: TestPrepGrade,
): void {
  const debouncedPageChangeHandler = useDebouncedCallback(
    async (pagePath: string, currentUserId: number, pageTestPrepGrade?: TestPrepGrade) => {
      const event = {
        eventName: EventType.VISIT_PAGE,
        viewKey: pagePath,
        extra: {
          detectBy: EventDetectionMethod.ROUTER_AS_PATH_CHANGED,
          testPrepGrade: pageTestPrepGrade,
        },
      }

      await logUserActivity(currentUserId, event)
    },
    300,
    { trailing: true, leading: false },
  )

  useEffect(() => {
    if (userId != null) {
      debouncedPageChangeHandler(router.asPath, userId, testPrepGrade)
    }
  }, [debouncedPageChangeHandler, router.asPath, testPrepGrade, userId])
}
